export default "__VITE_ASSET__03bbaecb__"